export const environment = {
  apiUrl: 'https://api-staging.realguest.it',
  appUrl: '',
  massMailingUrl: '',
  assetsBucketUrl: 'https://cdn-staging.realguest.it',
  clientUrl: 'https://checkin-staging.realguest.it',
  enableDebug: true,
  // AppSync real-time check-in. Still false: flip to true (and redeploy the API
  // Lambda so Phase B's lastCheckInData is live) to validate the GraphQL path on
  // staging before switching prod. The endpoint is the deployed staging AppSync
  // GraphQL URL (validated end-to-end incl. WS subscriptions by
  // infrastructure/scripts/validate-appsync.mjs). The custom domain
  // https://appsync-staging.realguest.it/graphql is the stable alternative.
  useAppSync: true,
  appSync: {
    endpoint: 'https://64ehwuqk7zgbxbqysntwh5okwy.appsync-api.eu-south-1.amazonaws.com/graphql',
    region: 'eu-south-1',
  },
};
